module.exports = __webpack_public_path__ + "img/VTC-alt.3d2f6463.svg";